<template>
  <div
    class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 border border-blueGray-200 rounded-lg"
  >
    <div class="rounded-t mb-0 px-4 py-3 border-0">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full px-4 max-w-full flex-grow flex-1">
          <h3 class="font-semibold text-base text-blueGray-700">
            Rate List
          </h3>
        </div>
        <div
          class="relative w-full px-4 max-w-full flex-grow flex-1 text-right"
        >
          <!-- <button
            class="bg-blueGray-900 text-white active:bg-blueGray-800 text-xs font-bold uppercase px-3 py-1 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
            type="button"
          >
            See all
          </button> -->
        </div>
      </div>
    </div>
    <div class="block w-full overflow-x-auto">
      <!-- Projects table -->
      <table class="items-center w-full bg-transparent border-collapse">
        <thead class="thead-light">
          <tr>
            <th
              class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
            >
              <i class="pi pi-dollar mr-1"></i>Currency
            </th>
            <th
              class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
            >
              <i class="pi pi-percentage mr-1"></i>Rate
            </th>
            <th
              class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left min-w-140-px"
            >
              <i class="pi pi-arrow-down mr-1"></i>Buy Rate
            </th>
            <th
              class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left min-w-140-px"
            >
              <i class="pi pi-arrow-up mr-1"></i>Sell Rate
            </th>
            <th
              class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left min-w-140-px"
            >
              <i class="pi pi-check-circle mr-1"></i>Active
            </th>
          </tr>
        </thead>
        <tbody >
          <template v-if="!loaders().getAllCurrencies">
          <tr v-for="(currency, i) in currencies" :key="i" class="cursor-pointer" @click="selectRate(currency)">
            <th
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left"
            >
              {{ currency.currency }}
            </th>
            <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
            >
              {{ currency.rate }}
            </td>
            <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
            >
              {{ currency.buy_rate }}
            </td>
            <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
            >
              {{ currency.sell_rate }}
            </td>
            <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
            >
              {{ currency.is_active }}
            </td>
          </tr>
          </template>
          <template v-else>
            <tr v-for="n in 6" :key="n">
              <td v-for="col in 5" :key="col" class="border-t-0 px-6 align-middle border-l-0 border-r-0 p-4">
                <div class="h-3 bg-blueGray-200 rounded animate-pulse" :style="{ width: ['85%','60%','70%','50%','65%'][(col-1) % 5] }"></div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <empty-list v-if="currencies.length === 0 && !loaders().getAllCurrencies"></empty-list>
    </div>
  </div>
</template>

<script>
import EmptyList from "@/components/Cards/EmptyList.vue";
import { mapGetters } from 'vuex';

export default {
  props: ["currencies"],
  components: {
    EmptyList
  },
  methods: {
    ...mapGetters(["loaders"]),
    selectRate(currency) {
      if (this.has('rates.show')) {
        this.$emit('selectedRate', currency)
      }
    }
  }
}
</script>
